import { render, staticRenderFns } from "./DictTag.vue?vue&type=template&id=1ca2c16c&scoped=true"
import script from "./DictTag.vue?vue&type=script&lang=js"
export * from "./DictTag.vue?vue&type=script&lang=js"
import style0 from "./DictTag.vue?vue&type=style&index=0&id=1ca2c16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca2c16c",
  null
  
)

export default component.exports